const HOST_URL = '';
export const BASE_URL = HOST_URL;
const HR_URL = HOST_URL + '/hr';

export const GATEWAY_URL = {
  user: HOST_URL + '/api/auth/user/',
  token: HOST_URL + '/api/auth/token/',
  refresh_token: HOST_URL + '/api/token-refresh/',
};

// The URL should be sorted alphabetically
export const API_URL = {
  add_user: '/api/add-user/',
  announcement: '/api/announcement/',
  batch_uploads: '/api/batch-uploads/',
  budget_master_types: '/api/budget-master-types/',
  budget_master_data: '/api/budget-master-data/',
  bulk_permanently_delete_memo: '/api/memos/bulk-permanently-delete/',
  bulk_trash_memo: '/api/memos/bulk-trash/',
  bulk_untrash_memo: '/api/memos/bulk-untrash/',
  bulk_update: '/api/configurations/bulk-update/',
  cc_group: '/api/cc-groups/',
  certificate: '/api/certificate/',
  change_password: '/api/change-password/',
  chatbot: '/api/chatbot/',
  close_otp: '/api/close-otp/',
  compress_pdf: '/api/compress-pdf/',
  contract: '/api/memos/contract/',
  configuration: '/api/configurations/',
  dashboard_storage: '/api/storage-report/',
  delegate_permission: '/api/user-delegate/',
  department_level: '/api/department-levels/',
  departments: '/api/departments/',
  categories: '/api/categories/',
  category_level: '/api/category-levels/',
  departments_tree: '/api/departments-tree/',
  download_merge_pdf: '/api/download-merge-pdf/',
  download_split_pdf: '/api/download-split-pdf/',
  dropdown: '/api/dropdown/',
  epoa_permissions: '/api/e-poa-permissions/',
  excel_file: '/api/example-invite-user-file/',
  finished_memo: '/api/memos/finished/',
  folder_items: '/api/folder-items/',
  folder_permission: '/api/folder-permissions/',
  folders: '/api/folders/',
  general_memo: '/api/memos/general/',
  budget_memo: '/api/memos/budget-request/',
  budget_dashboard: '/api/dashboard/budget-request/',
  guest_approve_memo: '/api/guest-approval-memo/',
  import: '/api/members-import/',
  invite_user: '/api/invite-user/',
  job_position: '/api/job-positions/',
  link_line_codium: '/api/line/codium/',
  link_line_user: '/api/line/user/',
  loa_groups: '/api/loa-groups/',
  budget_loa_groups: '/api/budget-loa-groups/',
  init_sig_pos: '/api/init-sig-pos/',
  login: '/api/token-auth/',
  logout: '/api/logout/',
  master_data_usage_logs: '/api/master-data-usage-logs/',
  me: '/api/me/',
  memo_attachment: '/api/memo-attachments/',
  memo_bulk_attachment: '/api/memo-attachments/bulk-create/',
  memo_comment: '/api/memo-comments/',
  memo_draft: '/api/memos-draft/',
  memo_link: '/api/memos-link/',
  memo_list_members: '/api/list-memo-numbers/',
  memo_logo: '/api/memos-logo/',
  memo_mentions: '/api/memos-comment/get_mention_profiles/',
  memo_number_verify: '/api/memos-verify-memo-number/',
  memo_organization: '/api/memos-organization/',
  memo_pdf2image: '/api/pdf2image/',
  memo_permissions: '/api/memo-permissions/',
  memo_preview: '/api/memos-preview/',
  memo_publish: '/api/memos-publish/',
  memo_read: '/api/memos-read/',
  memo_real: '/api/memos-real/',
  memo_resend_email: '/api/memos-resend-email/',
  memo_revised: '/api/get-revised-memo/',
  memo_send_email: '/api/memos-send-email/',
  memo_special_type: '/api/memos-special-type/',
  memo_template: '/api/memos-template/',
  memos: '/api/memos/',
  memos_history: '/api/memo-operation-logs/',
  merge_pdf: '/api/merge-pdf/',
  muted_notification: '/api/muted-notifications/',
  my_task: '/api/my-tasks/',
  news_feed_comment: '/api/news-feed/comments/',
  news_feed_post: '/api/news-feed-post/',
  news_related_post: '/api/news-feed-post/related-post/ ',
  notification: '/api/website-notifications/',
  notification_action: '/api/notification-actions/',
  notification_channel: '/api/notification-channels/',
  open_otp: '/api/open-otp/',
  operation_log: '/api/operation-logs/',
  people: '/api/people/',
  preview_memo: '/api/render_pdf/',
  profile_user_active: '/api/profile-user-activate/',
  profiles_files: '/api/profiles-files/',
  profiles_guest: '/api/profiles-guest/',
  profiles_name: '/api/profiles/all/',
  refresh_token: HOST_URL + '/api/api/token-refresh/',
  remove_memo_blob: '/api/remove-memo-blob/',
  remove_contract_blob: '/api/remove-contract-blob/',
  reset_password: '/api/password-reset/',
  reset_password_confirm: '/api/password-reset/confirm/',
  reset_password_validate: '/api/password-reset/validate_token/',
  setting_email: '/api/mail-notifications/',
  site_config: '/api/site-config/',
  package_storage_info: '/api/package-storage-info/',
  theme_active: '/api/theme-config/active/',
  themes: '/api/theme-config/',
  transfer_profile: '/api/transfer-profile/',
  upload_memo_blob: '/api/upload-memo-blob/',
  upload_memo_blob_multi: '/api/upload-memo-multi-blob/',
  upload_contract_blob: '/api/contract-blob/',
  upload_contract_blob_multi: '/api/contract-multi-blob/',
  upload_person_blob: '/api/upload-person-blob/',
  user_department: '/api/departments/',
  verify_otp: '/api/verify-otp/',
  watermark: '/api/watermarks/',
};
